import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { CategoriaRowSelect } from './CategoriaRowSelect'

export const CategoriaRowItem = ({categoria, editCategoria, deleteCategoria}) => {

    const { servicios } = useSelector(state => state.servicios);
    const { productos } = useSelector(state => state.productos);
    const [serviciosTxt, setServiciosTxt] = useState('');
    const [productosTxt, setProductosTxt] = useState('');

    useEffect(() => {
      procesaServicios();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [servicios]);
    
    useEffect(() => {
        procesaProductos();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [productos]);
    

    const procesaServicios = () => {
        const totalIncluidos = servicios.filter( servicio => {
            return categoria.servicios.includes( servicio._id );
        });
        if( totalIncluidos.length === 0 ){
            setServiciosTxt( 'Ninguno' );
        } else if( totalIncluidos.length === servicios.length ){
            setServiciosTxt( 'Todos' );
        } else {
            setServiciosTxt( 'Algunos' );
        }
    };
    
    const procesaProductos = () => {
        const totalIncluidos = productos.filter( producto => {
            return categoria.productos.includes( producto._id );
        });
        if( totalIncluidos.length === 0 ){
            setProductosTxt( 'Ninguno' );
        } else if( totalIncluidos.length === productos.length ){
            setProductosTxt( 'Todos' );
        } else {
            setProductosTxt( 'Algunos' );
        }
    };

    const clickDelete = () => {
        deleteCategoria( categoria );
    };

    return (
        <div 
            key={ categoria._id } 
            className='categoria-item'
            onClick={() => editCategoria( categoria )}
        >
            <div className='item-col col-categoria'>
                <h5>Categoria</h5>
                <p>{ categoria.nombre }</p>
            </div>
            <div className='item-col col-descripcion'>
                <h5>Descripcion</h5>
                <p>{ categoria.descripcion }</p>
            </div>
            <div className='item-col col-servicios'>
                <h5>Servicios</h5>
                <p>{ serviciosTxt }</p>
            </div>
            <div className='item-col col-productos'>
                <h5>Productos</h5>
                <p>{ productosTxt }</p>
            </div>
            <div className='item-col col-btns'>
                <CategoriaRowSelect
                    clickDelete={ clickDelete }
                />
            </div>
        </div>
    )
}
